import AuthenticatorApp, { Authenticator } from 'tlv-auth/src/services/auth/Auth.service'
export const AUTHENTICATOR_KEY = 'AUTHENTICATOR'

// install the plugin to vue as standard plugin
export const install = async (app, settings = {}) => {
  Authenticator.init(settings)
  app.provide('AUTHENTICATOR', AuthenticatorApp)
}
